var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGuessBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGuessBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2   0 0 0 0 0.2   0 0 0 0 0.2  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Platinum-upgrade",
    transform: "translate(-9.000000, -1426.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 1211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icGuessBlack",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-(2)",
    transform: "translate(12.000000, 11.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5381692,0 C8.53987852,0 5.27147072,3.26840781 5.27147072,7.26669848 C5.27147072,11.2649892 8.53987852,14.533397 12.5381692,14.533397 C16.5364599,14.533397 19.8048677,11.2649892 19.8048677,7.26669848 C19.8048677,3.26840781 16.5364599,0 12.5381692,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0089805,20.3403905 C24.8185683,19.8643905 24.5647462,19.4201562 24.2791584,19.0076269 C22.8194534,16.8498048 20.5665163,15.4218655 18.0279306,15.0728069 C17.7106377,15.041102 17.3615792,15.1045119 17.1076963,15.2949241 C15.7749328,16.2786291 14.1883471,16.7863341 12.5382299,16.7863341 C10.8881128,16.7863341 9.30152711,16.2786291 7.96876356,15.2949241 C7.71488069,15.1045119 7.36582213,15.0093362 7.04852928,15.0728069 C4.5099436,15.4218655 2.22524078,16.8498048 0.797301518,19.0076269 C0.511713666,19.4201562 0.257830803,19.8961562 0.0674793926,20.3403905 C-0.0276963124,20.5308026 0.00400867679,20.7529197 0.0991843818,20.9433319 C0.353067245,21.3875662 0.670360087,21.8318612 0.955947939,22.2126247 C1.40018221,22.8155662 1.87618221,23.3549761 2.41565293,23.8626811 C2.8598872,24.3069154 3.36759219,24.7194447 3.87535792,25.131974 C6.38217787,27.0042082 9.39676356,27.9878525 12.5065249,27.9878525 C15.6162863,27.9878525 18.630872,27.0041475 21.137692,25.131974 C21.645397,24.7512104 22.153102,24.3069154 22.597397,23.8626811 C23.105102,23.3549761 23.6128069,22.8155054 24.057102,22.2126247 C24.3743948,21.8000954 24.6600434,21.3875662 24.9138655,20.9433319 C25.0724512,20.7529197 25.1041562,20.5307419 25.0089805,20.3403905 Z",
    id: "Path"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuessBlack);
export default __webpack_public_path__ + "static/media/icGuessBlack.1a755a97164bfd33a544f4dc7f2c71fc.svg";
export { ForwardRef as ReactComponent };